export var Events;
(function (Events) {
    Events["RestoreFileChannel"] = "urn:event:file:restore";
    Events["DeleteFileChannel"] = "urn:event:file:delete";
    Events["PreviewFileChannel"] = "urn:event:file:preview";
    Events["SelectedFileChannel"] = "urn:event:file:selected";
    Events["RenameFileChannel"] = "urn:event:file:rename";
    Events["UploadFileStartChannel"] = "urn:event:file:upload-start";
    Events["UploadFileCompleteChannel"] = "urn:event:file:upload-complete";
    Events["UploadFileCancelChannel"] = "urn:event:file:upload-cancel";
    Events["DownloadFileChannel"] = "urn:event:file:download";
    Events["PermanentDeleteFileChannel"] = "urn:event:file:delete-permanent";
    Events["CountUpdated"] = "urn:event:file:count-updated";
    Events["CreateFolderChannel"] = "urn:event:file:folder-create";
    Events["LinkToContainerChannel"] = "urn:event:resource:link";
    Events["UnLinkToContainerChannel"] = "urn:event:resource:unlink";
    Events["MoveFileChannel"] = "urn:event:file:move";
    Events["CopyFileChannel"] = "urn:event:file:copy";
    Events["AddOrEditDescriptionChannel"] = "urn:event:file:add-or-edit-description";
})(Events || (Events = {}));
//# sourceMappingURL=events.js.map